<template>
  <div class="login">
    <div class="loginWrapper">
      <div class="mx-auto max-w-md w-full loginScreen" :class="{ submitting: submitting == true }">
        <form v-if="!forgotPassword" @submit.prevent="passwordSubmit">
          <img src="@/assets/neou-logo.png" class="neouLogo" />
          <h1 class="signIn">
            Set a new password below
          </h1>
          <md-field :class="getValidationClass('password')">
            <label>Password (8+ characters)</label>
            <md-input v-model="form.password" type="password"></md-input>
            <span class="md-error" v-if="!$v.form.password.required">password is required</span>
            <span class="md-error" v-else-if="!$v.form.password.minLength">password must be longer than 8 characters</span>
          </md-field>
          <md-field :class="getValidationClass('confirmPassword')">
            <label>Confirm Password</label>
            <md-input v-model="form.confirmPassword" type="password"></md-input>
            <span class="md-error" v-if="!$v.form.confirmPassword.sameAsPassword">passwords must match</span>
          </md-field>
          <md-button class="md-raised neouButton" type="submit">
            <md-progress-spinner md-mode="indeterminate" :md-diameter="20" :md-stroke="2"></md-progress-spinner>Continue
          </md-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  MdField,
  MdButton,
  MdProgress,
  MdIcon
} from "vue-material/dist/components";
import { validationMixin } from "vuelidate";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import "@/assets/tweaked-vue-material.min.css";
import axios from "axios";
import cryptLib from "@skavinvarnan/cryptlib";
import * as firebase from "firebase";
import { parse } from "query-string";

Vue.use(MdField);
Vue.use(MdIcon);
Vue.use(MdButton);
Vue.use(MdProgress);

export default {
  name: "CapitalOneSetPassword",
  mixins: [validationMixin],
  data: () => ({
    form: {
      password: null,
      confirmPassword: null,
    },
    emailPassed: false,
    isUserExist: false,
    isValidEmail: false,
    submitting: false,
    isSocialLogin: false,
    isAppleLogin: false,
    isVLUser: false,
    forgotPassword:false,
    passwordResetSent: false,
    hideSocial: false,
    isCof: false,
    id: "",
    params: {}
  }),
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8)
      },
      confirmPassword: {
        sameAsPassword: sameAs("password")
      }
    }
  },
  mounted: function() {
    window.dataLayer.push({
      event: "cap_one_password",
    });
  },
  beforeMount: function() {
  },
  methods: {
    getValidationClass: function(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    passwordSubmit() {
      this.submitting = true;
      this.$v.form.password.$touch();
      this.$v.form.confirmPassword.$touch();
      if (!this.$v.form.$invalid) {
        let api = "";
        let body = {};
        let oldPassword = cryptLib.encryptPlainTextWithRandomIV(
            "Neou@123",
            "DWIzFkO22qfVMgx2fIsxOXnwz10pRuZfFJBvf4RS3eY="
          );
        let cryptPassword = cryptLib.encryptPlainTextWithRandomIV(
          this.form.password,
          "DWIzFkO22qfVMgx2fIsxOXnwz10pRuZfFJBvf4RS3eY="
        );
        api = "https://contentapi.neoufitness.com/neouadmin/v1/members/delete-add-user";
        body = {
          email: this.$attrs.email.toLowerCase(),
          newPwd: this.form.password
        };
        // Identify the new user
        // window.analytics.identify(userId, {
        //   account_type: type,
        //   email: email,
        //   user_group: "No Fitness Profile",
        //   initial_platform: "Web",
        //   country_of_registration: this.countryCode
        // });
        // Delete and Re-add user with API
        axios
          .post(api, body)
          .then(res => {
            api = 'https://api.neoufitness.com/neou/v1/user/login';
            body = {
              password: cryptPassword,
              email: this.$attrs.email
            }
            // Log the user in
            axios
            .post(api, body, {
              headers: {
                Authorization: "JWT " + this.$cookie.get("token")
              }
            })
            .then(res => {
              console.log( res );
              window.analytics.identify(res.data.userData.id);
              this.$cookie.set("getUserToken", res.data.token);
              //Remove the Users Subscription
              let redeemURL = "https://redeem.neoufitness.com/removeSubscription?user=" + encodeURIComponent(res.data.userData.id);
              axios
                .get(redeemURL)
                .then(res => {
                  this.getUser();
                })
                .catch(err => {
                  console.log("no entitlement found");
                  this.getUser();
                });
            })
            .catch( err => {
              console.error("couldnt update password");
            });
          })
          .catch(err => {
            // delete-add-user failed, Try to create the user
            console.log(this.$attrs.email.toLowerCase());
            console.error("couldnt delete-add-user");
            axios
              .post('https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyAiQCgtZRAf3EyHDpmoNxeuAfxo9XB4i0Y', {
                  email: this.$attrs.email,
                  password: this.form.password
              })
              .then(res => {
                // Log in that user
                api = 'https://api.neoufitness.com/neou/v1/user/login';
                body = {
                  password: cryptPassword,
                  email: this.$attrs.email
                }
                axios
                  .post(api, body, {
                    headers: {
                      Authorization: "JWT " + this.$cookie.get("token")
                    }
                  })
                  .then(res => {
                    // Set user token and then remove their subscription
                    console.log( res );
                    window.analytics.identify(res.data.userData.id);
                    this.$cookie.set("getUserToken", res.data.token);
                    //Remove the Users Subscription
                    let redeemURL = "https://redeem.neoufitness.com/removeSubscription?user=" + encodeURIComponent(res.data.userData.id);
                    axios
                      .get(redeemURL)
                      .then(res => {
                        this.getUser();
                      })
                      .catch(err => {
                        this.getUser();
                      });
                  })
                  .catch( err => {
                    console.error("created user but couldnt log in");
                  });
              })
              .catch(err => {
                console.error("couldnt create user")
              });
          });
      } else {
        this.submitting = false;
      }
    },
    getUser() {
      // get user
      axios
        .get("https://api.neoufitness.com/neou/v1/user", {
          headers: {
            Authorization: "JWT " + this.$cookie.get("token"),
            token: this.$cookie.get("getUserToken")
          }
        })
        .then(res => {
          this.$emit("setUser", res.data.result.id);
          this.$emit("setEmail", this.$attrs.email);
          this.$emit("setStripeId", res.data.result.stripeId);
          setTimeout(() => {
              window.dataLayer.push({
                event: "cap_one_password_success",
              });
            this.$emit("nextScreen");
          }, 1000);
        })
        .catch(err => {
          console.error("couldnt get user");
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.forgotPasswordContainer{
  width:100%;
  text-align:center;
  margin-top:20px;
}
.forgotSuccessHeader{
    font-family: "prox", Helvetica;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  margin-top:50px;
}
.forgot{
font-size: 11px;
  line-height: 14px;
  text-align: right;
  margin: 0px 0px 10px 0px;
  display:block;
  color: #505B63;
  text-decoration:underline;
  cursor:pointer;


  a{
    color:#56fffe;
    cursor:pointer;
  }
}
.submitting {
  .neouButton {
    color: transparent;
  }
  .md-progress-spinner {
    display: inline-flex;
  }
}
.md-progress-spinner {
  stroke: black;
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  display: none;
}
.login {
  position: relative;
  max-width: 400px;
  padding: 0px 15px;
  margin: 0px auto;
  width: 100%;
  color:#12161A;
}
.loginWrapper {
  display: flex;
  justify-content: center;
}
.loginScreen {
  width: 280px;
  padding: 40px 0px;
  position: relative;
  z-index: 2;
}
.neouLogo {
  width: 140px;
  margin: 0px auto;
  display: block;
  filter:invert(1);
}
.welcomeBack {
  text-align: center;
  font-style: italic;
  font-size: 40px;
}
.featureList {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
.feature {
  margin: 5px 0px;
}
.checkmark {
  margin: 0px 10px 0px 0px;
}
.regularText {
  text-align: center;
}
.signIn {
  font-family: "prox", Helvetica;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  margin: 40px 0px 20px 0px;
}
.md-field:after {
  border-bottom: 1px solid #35414a;
}
.md-field label {
  color: #8b949b;
  font-style: italic;
}
.md-field .md-input {
  color: #12161A;
}
.termsLink {
  font-size: 11px;
  line-height: 14px;
  text-align: center;
  margin: 18px 0px;
  color: rgb(140, 148, 155);

  a {
    color: rgb(140, 148, 155);
    text-decoration:underline;
  }
}
.md-toggle-password {
  color: #35414a;
}
.orLine {
  overflow: hidden;
  padding: 0px;
  text-align: center;
  color: #35414a;
  line-height: 40px;
  width: 100%;
  &:before,
  &:after {
    background-color: #35414a;
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 40%;
    color: #35414a;
  }
  &:before {
    right: 0.5em;
    margin-left: -25%;
  }
  &:after {
    left: 0.5em;
    margin-right: -25%;
  }
  span {
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    padding: 20px;
    color: #8c949b;
    font-weight: bold;
  }
}
.iconApple {
  position: absolute;
  left: -35px;
  top: 50%;
  transform: translateY(-50%);
}

.iconFacebook{
  position: absolute;
  left: -35px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
